import React from "react";
import { MenuItem } from "@material-ui/core";

import { ResponsiveTableCell } from "../../../../components/layout/responsive-table/responsive-table-cell.component";
import { BuyGetStatus } from "../../../../types/product/ibrief-product/buy-get-status.enum";
import { makeKey } from "../../../../utils/helpers";
import { withShowIf } from "../../../../components/with-show-if/with-show-If.component";

import { ProductTableBuyGetColumnsProps } from "./product-table-buy-get-columns.props";
import { BuyGetSelect } from "./components/buy-get-select/buy-get-select.component";

export const ProductTableBuyGetColumns = withShowIf((props: ProductTableBuyGetColumnsProps) => {
  const isBuy = () => props.buyGetStatus === BuyGetStatus.Buy;

  return (
    <>
      <ResponsiveTableCell className="wide" align="left">
        <BuyGetSelect
          hasError={!!props.errors?.buyGetStatus}
          control={props.control}
          name={`products.${props.index}.buyGetStatus`}
          onChange={props.onStatusChange}
        >
          <MenuItem value={BuyGetStatus.Buy} key="Buy">
            Buy
          </MenuItem>
          <MenuItem value={BuyGetStatus.Get} key="Get">
            Get
          </MenuItem>
          <MenuItem value={BuyGetStatus.Neither} key="Neither">
            Neither
          </MenuItem>
        </BuyGetSelect>
      </ResponsiveTableCell>

      <ResponsiveTableCell>
        <BuyGetSelect
          hasError={!!props.errors?.relatedGetProductIds}
          showIf={isBuy()}
          control={props.control}
          name={`products.${props.index}.relatedGetProductIds`}
          onChange={props.onRelatedChange}
          multiple
        >
          {props.workOrderGetProductsList.map((i: number) => (
            <MenuItem value={i} key={makeKey(props.index, i)}>
              {i}
            </MenuItem>
          ))}
        </BuyGetSelect>
      </ResponsiveTableCell>
    </>
  );
});
